const minigameData = {
	id: 'm6-change-negative-thoughts',
	title: 'Tankelabyrinter til brugbare',
	playBtnText: 'Start øvelse',
	viewBtnText: 'Se elevsvar',
	parts: [
		{
			id: 1,
			type: 'change-thoughts',
			introPopupText: `Omformuler de negative tanker til brugbare tanker.`,
			infoPopupText: `Omformuler de negative tanker til brugbare tanker.`,
			options: [
				'Jeg fik 02 i terminsprøven, så nu går det helt galt til eksamen. Jeg kommer ikke til at bestå',
				'Når vi skal på lejrskole, kommer jeg helt sikkert til at sidde helt alene, mens de andre bare hygger sig sammen på deres værelser',
				'Den dårlige stemning er min skyld, det er nok, fordi jeg er kedelig',
				'Min kammerat skrev ikke til mig i går. Det er nok, fordi han synes jeg er for meget',
				'Sådan er det bare. Jeg er alligevel én, de andre ikke gider at være sammen med',
				'Sidste idrætstime var nederen, så det bliver sikkert også nederen i dag',
				'Enten rykker jeg op på et andet hold i fodbold, eller også stopper jeg',
				'Jeg skal have nul fejl i den her prøve, ellers kan det være lige meget'
			],
			placeholder: `Skriv en negativ tanke om til en brugbar tanke og tryk på knappen SEND TIL UNDERVISERS SKÆRM, inden du skriver den næste.`,
			submitBtnText: `SEND TIL UNDERVISERS SKÆRM`,
			title: 'Omformuler de negative tanker til brugbare tanker',
			titleGroup: 'Negative tanker til brugbare tanker',
			textGroup: `Vælg 2-3 sætninger fra listen, I vil omskrive til brugbare tanker. Send dem afsted en ad gangen.`
		},
	],
	submissions: {

	}
};

export {
	minigameData
}